export default [
  'id', 'seq_id', 'animal_id', 'photo', 'photos', 'animal_name', 'animal_status'
]